<template>
    <Transition
        enter-active-class="transition-opacity duration-300"
        leave-active-class="transition-opacity duration-300"
        enter-from-class="opacity-0"
        leave-to-class="opacity-0"
    >
        <div
            v-show="current"
            ref="viewport"
            class="absolute inset-0 z-10 overflow-hidden bg-black bg-[url('@/assets/images/games/killer/killerBg.png')] bg-size-[auto_100%] bg-center"
        >
            <div
                class="absolute top-1/2 left-1/2 h-[844px] w-[393px]"
                :style="{ transform: `translate(-50%, -50%) scale(${scale})` }"
            >
                <Transition
                    enter-active-class="transition-opacity duration-300"
                    leave-active-class="transition-opacity duration-300"
                    enter-from-class="opacity-0"
                    leave-to-class="opacity-0"
                >
                    <component
                        :is="currentComponent"
                        v-if="current"
                        :key="current.id"
                        v-bind="current.props"
                        @main-menu="$emit('main-menu')"
                    />
                </Transition>
            </div>
        </div>
    </Transition>
</template>

<script>
import KillerSplashBecameKiller from './KillerSplashBecameKiller.vue'
import KillerSplashEliminated from './KillerSplashEliminated.vue'
import KillerSplashStart from './KillerSplashStart.vue'
import KillerSplashTurn from './KillerSplashTurn.vue'
import KillerSplashWin from './KillerSplashWin.vue'

const STAGE_WIDTH = 393
const STAGE_HEIGHT = 844

const SPLASHES = {
    start: { component: KillerSplashStart, duration: 3000 },
    turn: { component: KillerSplashTurn, duration: 1500, latestOnly: true },
    becameKiller: { component: KillerSplashBecameKiller, duration: 2000 },
    eliminated: { component: KillerSplashEliminated, duration: 2000 },
    win: { component: KillerSplashWin, duration: null },
}

export default {
    name: 'KillerSplashHost',
    emits: ['main-menu'],
    data() {
        return {
            current: null,
            pending: [],
            nextId: 0,
            timer: null,
            scale: 1,
            resizeObserver: null,
        }
    },
    computed: {
        currentComponent() {
            return this.current ? SPLASHES[this.current.type].component : null
        },
    },
    mounted() {
        this.resizeObserver = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect
            if (width && height) {
                this.scale = Math.min(width / STAGE_WIDTH, height / STAGE_HEIGHT)
            }
        })
        this.resizeObserver.observe(this.$refs.viewport)
    },
    beforeUnmount() {
        clearTimeout(this.timer)
        this.resizeObserver?.disconnect()
    },
    methods: {
        show(type, props) {
            if (SPLASHES[type].latestOnly) {
                this.pending = this.pending.filter((splash) => splash.type !== type)
            }
            this.pending.push({ id: ++this.nextId, type, props })
            if (!this.current) this.showNext()
        },
        showNext() {
            clearTimeout(this.timer)
            this.current = this.pending.shift() || null
            const duration = this.current && SPLASHES[this.current.type].duration
            if (duration) this.timer = setTimeout(this.showNext, duration)
        },
    },
}
</script>
